<template>
  <div class="opc-coupon__wrap __PLACEHOLDER_coupon__" v-if="isRenderCoupon" v-show="isShowCoupon">
    <!-- for special support all product/transaction coupon form -->
    <support-coupon-form ref="couponForm" v-if="showSpecialSupportCouponForm" />
    <!-- for regular coupon form -->
    <template v-else-if="showRegularCouponForm">
      <zm-button data-testid="checkout-button-392" class="opc-coupon__add--coupon" v-if="initMode" type="link" @click="switchToEditMode">
        {{ $t('billing.coupon.add_coupon_code') }}
      </zm-button>
      <opc-coupon-form ref="couponForm" v-else />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import OpcCouponForm from '@/views/config/coupon/coupon-form';
import { couponFetchStatus, couponFormModeMap } from '@/views/config/coupon/helper/constant';
import { isEmptyVal } from '@/utils';
import SupportCouponForm from '@/views/config/coupon/component/support-coupon/support-coupon-form.vue';
import { SupportCouponModeMap } from '@/views/config/coupon/component/support-coupon/constant';
import { promotionInstanceInfo } from '@/common/mixin/promotion-mixin';
import { PROMOTION_TYPE } from '@/views/config/coupon/helper/constant';
import { isIncreasePriceForPH } from '@/common/hardcode';
import _ from "lodash";

export default {
  components: { SupportCouponForm, OpcCouponForm },
  computed: {
    ...mapGetters(['getSelectedPlans', 'couponFormMode', 'couponState', 'isFromPartnerRefer', 'fromCampaignLink', 'forNewSubscriptionFlow', 'partnerRefer', 'eligiblePartnerReferOffer', 'useSpecialSupportCoupon', 'supportCouponState', 'softBundleState', 'softBundleConfiguration']),
    showCouponForSoftBundleCase() {
      const showCouponFormWhenBundleInEligible = this.softBundleConfiguration.config?.showCouponFormWhenBundleInEligible || false;

      if (!showCouponFormWhenBundleInEligible) {
        return false;
      }

      if (
        (this.softBundleState.lastStatus === couponFetchStatus.failure && this.softBundleState.isPending)
        || this.softBundleState.isFailure
      ) {
        return true;
      }

      return false;
    },
    initMode() {
      return this.couponFormMode === couponFormModeMap.INIT;
    },
    isShowCouponWithPartner() {
      const partnerRefer = this.partnerRefer;
      const partnerReferRules = partnerRefer?.rules;

      // for replace subscription &
      // partner refer just validate by referral coupon code not redeem this coupon
      if (
        partnerReferRules?.validateByReferralCoupon
        && !isEmptyVal(partnerRefer?.referralCouponCode)
        && !this.forNewSubscriptionFlow
      ) {
        return false;
      }

      // allow zoom coupon with partner refer
      if (partnerReferRules?.allowUseZMCoupon) {
        return true;
      }

      if (this.eligiblePartnerReferOffer) {
        return false;
      }

      // replace subscription
      if (!this.forNewSubscriptionFlow) {
        return false;
      }

      return true;
    },
    showRegularCouponForm4PromoCodeCampaign() {
      return this.$context.is.fromPromoCodeCampaign;
    },
    showRegularCouponForm() {
      if (this.isFromPartnerRefer) {
        return this.isShowCouponWithPartner;
      }

      if (this.forNewSubscriptionFlow) {
        return true;
      }

      if (this.fromCampaignLink) {
        return true;
      }

      if (this.showRegularCouponForm4PromoCodeCampaign) {
        return true;
      }

      return false;
    },
    showSpecialSupportCouponForm() {
      if (this.supportCouponState?.couponDisplayMode !== SupportCouponModeMap.form) {
        return false;
      }

      if (this.useSpecialSupportCoupon) {
        return true;
      }

      return false;
    },
    isRenderCoupon() {
      if (!this.hasSupportCoupon) return false;
      return this.showSpecialSupportCouponForm || this.showRegularCouponForm;
    },
    isShowCoupon() {
      if (this.partnerRefer?.features?.hiddenCouponForm) {
        return this.showCouponForSoftBundleCase;
      }
      if (this.$context.is.switchCurrency) return false;
      return true;
    },
    hasSupportCoupon() {
      return !isIncreasePriceForPH()
        && _.find(this.getSelectedPlans, item => item.supportCoupon)
        && !window?.newBillingConfig?.allowMSQAccountOnlineSelfService
        && this.getSelectedPlans?.length > 0;
    },
  },
  methods: {
    ...mapMutations(['setCouponFormMode']),
    switchToEditMode() {
      this.setCouponFormMode(couponFormModeMap.EDIT);
      this.$nextTick(() => this.$refs?.couponForm?.focus());

      this.$tracking.buyInteraction(
        'order summary',
        'add coupon code'
      )
    },
    couponVerifyAction(){
      this.$refs?.couponForm?.autoVerifyCouponAction();
    },
    async autoVerifyAction() {
      if (!this.isRenderCoupon) return;
      // use $nextTick alternative to ensure $refs is available
      await this.$nextTick();
      this.couponVerifyAction();
    }
  },
  watch: {
    'couponState.couponCode': {
      immediate: true,
      handler(couponCode) {
        couponCode && this.setCouponFormMode(couponFormModeMap.EDIT);
      },
    },
  },
  created() {
    promotionInstanceInfo.setPromotionInstance(PROMOTION_TYPE.coupon, this);
  },
  beforeDestroy() {
    // Clean up promotion instance to prevent memory leaks
    promotionInstanceInfo.removePromotionInstance(PROMOTION_TYPE.coupon);
  }
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-coupon {
  &__add--coupon {
    padding: 0px;
    font-weight: 700;
    font-size: 14px;

    @include media(desktop) {
      scroll-margin-bottom: 200px;
    }

    &.zm-button--link {
      color: $theme-color;
    }
  }
}
</style>
